// import ExampleCarouselImage from "components/ExampleCarouselImage";
import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { API_URL_FILE, APPLICATION_IMG_URL } from "../Utils/constants";

const CustomCarousel = ({ slides }) => {
  const [index, setIndex] = useState(0);

  const source = API_URL_FILE + "/" + APPLICATION_IMG_URL;

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel
      activeIndex={index}
      onSelect={handleSelect}
      slide={false}
      prevLabel={""}
      nextLabel={""}
      interval={null}
    >
      {slides &&
        slides.length > 0 &&
        slides.map((slide, i) => (
          <Carousel.Item key={i}>
            {/* <ExampleCarouselImage text="First slide" /> */}
            <img
              className="d-block w-100"
              src={source + slide.name}
              alt="imges"
              style={{ height: "500px" }}
            />
          </Carousel.Item>
        ))}
    </Carousel>
  );
};

export default CustomCarousel;
